<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-sm" (click)="compOffRequest()"
                [disabled]="isDisabled">
                <i class="bi bi-suitcase" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Compensatory Off Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-2 p-0">
    <div class="card-header">
        <div class="card-title">
            Compensatoryoff Request History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
                            (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" readonly required (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select status!
                    </div>
                </div>
                <div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;">View</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>
                        <th style="width: 600px;" style="display: none;">Branch Name</th>
                        <th style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            Client Location</th>
                        <th style="width: 50px;">Designation Name</th>
                        <th style="width: 50px;">RequestDate</th>
                        <th style="width: 50px;">AttendanceDate</th>
                        <th style="width: 50px;">InTime</th>
                        <th style="width: 50px;">OutTime</th>
                        <th style="width: 10px;">HalfDay</th>
                        <th style="width: 50px;">HalfDay Session</th>
                        <th>Status</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;">
                            <div style="width: 70px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="openCompoffDetails(TableData.EmployeeCompOffDetailId)"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || common.ToLowerCase(TableData['ApprovalStatus']) == 'approved'">
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="SaveEmployeeCompOffDetails(i)"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button>
                            </div>
                        </td>
                        <td style="width: 600px;" style="display: none;">
                            <div style="width: 200px;">{{TableData['BranchName']}}</div>
                        </td>
                        <td style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            <div style="width: 200px;">{{TableData['ClientLocation']}}</div>
                        </td>
                        <td style="width: 50px;">
                            <div style="width: 150px;">{{TableData['DesignationName']}}</div>
                        </td>
                        <td style="width: 50px;">{{TableData['RequestDate']}}</td>
                        <td style="width: 50px;">{{TableData['AttendanceDate']}}</td>
                        <td style="width: 50px;">{{TableData['InTime'] | date : 'HH:mm'}}</td>
                        <td style="width: 50px;">{{TableData['OutTime'] | date : 'HH:mm'}}</td>
                        <td style="width: 10px;">{{TableData['HalfDay']?'Yes':'No'}}</td>
                        <td style="width: 50px;">{{TableData['HalfDaySession']}}</td>
                        <td><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>